import React from 'react';

import {ProgressBarInnerWrapperDiv, ProgressLine} from './ProgressBar.styles';

const ProgressBar = ({width, bgColor}) => (
  <ProgressBarInnerWrapperDiv>
    <ProgressLine width={width} bgColor={bgColor} />
  </ProgressBarInnerWrapperDiv>
);

export default ProgressBar;
